<div class="task-status text-uppercase fw-bold">
  <div class="row g-0 flex-nowrap" [ngClass]="taskStatusDisplay.textColor">
    <div class="col-auto pe-1">
      <mat-icon>{{ taskStatusDisplay.iconName }}</mat-icon>
    </div>
    <div class="col-auto">{{ task.humanizedStatus }}</div>
  </div>
</div>
